module.exports = __webpack_public_path__ + "static/media/image12.24389ee7.jpg";